module.exports = __webpack_public_path__ + "static/media/Precast-Concrete.157e1443.jpeg";